// extracted by mini-css-extract-plugin
export var header = "Header-module--header--28uoL";
export var headerSticky = "Header-module--headerSticky--1ts8-";
export var logoWhite = "Header-module--logoWhite--1KODw";
export var logo = "Header-module--logo--1kkRW";
export var menuItem = "Header-module--menuItem--1-EFJ";